import { Input, Select, Form, Switch, Divider, Tooltip, Button } from 'antd';
import { NotificationDevice } from '../../../../Models/Devices/NotificationDevice';
import { useTranslation } from 'react-i18next';
import { TypeModule } from '../../../../Models/Devices/TypeModule';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

import { BarcodeOutlined } from '@ant-design/icons';

export const EditNotificationGlobal = forwardRef(
  (
    props: {
      allData?: NotificationDevice[];
      data?: NotificationDevice;
      onCancel: Function;
      onSafe: Function;
    },
    ref,
  ) => {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();

    const [globalData, setGlobalData] = useState<NotificationDevice>();

    useImperativeHandle(ref, () => ({
      SafeGlobal() {
        form.submit();
        form.validateFields({ validateOnly: true }).then(
          (values: NotificationDevice) => {
            values.id = props.data!.id;
            values.connectedSensorsBoolean =
              props.data!.connectedSensorsBoolean;
            values.connectedSensorsNumber = props.data!.connectedSensorsNumber;
            props.onSafe(values);
          },
          () => {
            props.onSafe(null);
          },
        );
      },
    }));

    useEffect(() => {
      form.resetFields();
      setGlobalData(props.data);
    }, [form, props.data, globalData]);

    const onFinishForm = (item: any) => {};
    const onFinishFormFailed = (errorInfo: any) => {};

    const checkLabelExist = (_: any, value: string) => {
      var foundItem = props.allData?.find((x) => x.moduleName === value);
      if (foundItem !== undefined) {
        if (foundItem.id === props.data?.id) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('Deze email bestaat al'));
      }
      return Promise.resolve();
    };

    const GetModuleType = () => {
      return [
        { value: TypeModule.Logo, label: 'Logo' },
        { value: TypeModule.Esp32, label: 'Esp 32' },
        { value: TypeModule.S7, label: 'S7' },
      ];
    };

    return (
      <>
        <Divider>{t('edit')}</Divider>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={globalData}
          onFinish={onFinishForm}
          onFinishFailed={onFinishFormFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label={t('moduleName')}
            name="moduleName"
            key="moduleName"
            required
            rules={[
              {
                required: true,
                message: 'Email is vereist',
              },
              { validator: checkLabelExist },
            ]}
          >
            <Input />
          </Form.Item>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Form.Item
              style={{ width: 540 }}
              label={t('moduleId')}
              name="moduleId"
              key="moduleId"
              rules={[
                { required: true, message: t('fillfield').toString() },
                { validator: checkLabelExist },
              ]}
            >
              <Input />
            </Form.Item>
            <Tooltip title={t('generateId')}>
              <Button
                onClick={() => form.setFieldValue('moduleId', uuidv4())}
                style={{ marginLeft: 10 }}
                icon={<BarcodeOutlined />}
              ></Button>
            </Tooltip>
          </div>
          <Form.Item
            label={t('typeModule')}
            name="typeModule"
            key="typeModule"
            rules={[{ required: true, message: 'Vul een naam in' }]}
          >
            <Select options={GetModuleType()}>
              <Select.Option value="demo">Demo</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={t('enableNotifications')}
            name="enableNotifications"
            key="enableNotifications"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={t('enableSound')}
            name="enableSound"
            key="enableSound"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={t('visible')}
            name="visible"
            key="visible"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Form>
      </>
    );
  },
);
